import { OnInit, Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { trigger, style, transition, animate, state } from '@angular/animations';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { Router } from '@angular/router';
import { DialogService } from '../../../dialog/dialog.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { ChartService } from '../../services/chart.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';

@Component({
    selector: 'data-grid-widget',
    templateUrl: './data-grid-widget.component.html',
    styleUrls: ['./data-grid-widget.component.scss'],
    animations: [
        trigger('expand', [
            state('in', style({ height: '*' })),
            transition(':leave', [
                style({ height: '*' }),
                animate(250, style({ height: 0 }))
            ]),
            transition(':enter', [
                style({ height: 0 }),
                animate(250, style({ height: '*' }))
            ])
        ])
    ],
    host: { '[@expand]': 'in' },
    standalone: false
})
export class DataGridWidgetComponent implements OnInit {
    
  @Input() data: any;
  @Input() hideLabels: any;
  @Input() chartDataSets: any;
  @Input() chartLabels: any;
  @Input() chartOptions: any;
  @Input() chartColors: any;
  @Input() chartLegend: any;
  @Input() chartPlugins: any;
  @Input() chartType: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  public _currentData:any = {};
  intervals: any = [];
  filterType = 'fixed';
  timePeriodList: any;
  chartData: any;
  tableDataSets: any;
  config: any = {};
  @ViewChild('kxChart') kxChart: any;
  
    constructor(private baseService: BaseService, 
      private appService: AppService, 
      private loader: LoaderService,
      public router: Router,
      public dialogService:DialogService,
      public storage: StorageService,
      public chartService: ChartService,
      public alerts: AlertsService
      ) {
    }

    ngOnInit() {
      this._currentData.dataList = [];
      if (this.data) {
        this.chartService.getTimePeriod((timePeriodList)=>{
          this.timePeriodList = timePeriodList;
        })
        this.chartService.getWidget(this.data,(res)=>{
          this.data = res.data;
          this.prepareData();
        });
      }
    }
    getData(){
      if(this.filterType == 'fixed'){
        this.configChanged.emit({config:{interval:this.data.interval}})
        this.prepareData();
      }
    }
    setFilter(event) {
      console.log('eventis', event)
      this.data.time_period = event.target.value;
      this.configChanged.emit({config:{time_period:this.data.time_period}})
      this.prepareData();
    }
    valueChange(e,q){
      var res = this.chartService.valueChange(e,q,this.data);
      if(res){
        this.prepareData();
      }   
     }
    prepareData(){
      this.config.objData  = false;
      this.data.filterType = this.filterType;
      setTimeout(()=>{
        this.chartService.getDrilldown(this.data,(tempData)=>{
          this.config.objData = {data:tempData};
        });
      });
    }

   
}